import User, { getUser } from "core/models/user";
import { PermissionService } from "core/services/cef";
import { UpdateUserDetailsRequest } from "core/services/cef/permission.service.types";
import getUserDetailsAsync from "./get-user-details";

export const updateProfileAsync = async (firstName: string, lastName: string) => {
    if (!User.instance && !getUser()) {
        return;
    }

    const service = new PermissionService();

    const request: UpdateUserDetailsRequest = {
        firstName,
        lastName,
        email: User.instance?.email ?? ""
    }

    const cefUpdateResponse = await service.updateUserDetails(request);

    console.dir(cefUpdateResponse);

    await getUserDetailsAsync();

    return cefUpdateResponse;
}

export default { updateProfileAsync }
